import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=19136b30&scoped=true&"
import script from "./shoppingcart.js?vue&type=script&lang=js&"
export * from "./shoppingcart.js?vue&type=script&lang=js&"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=19136b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19136b30",
  null
  
)

export default component.exports